export function EmbedSkeleton() {
  return (
    <div className="w-full bg-white px-2 py-1">
      <div className="mb-1 h-5 w-8 animate-pulse rounded bg-gray-200" />
      <div className="flex flex-col gap-2 md:flex-row">
        <div className="h-[300px] w-full animate-pulse rounded-lg bg-gray-100" />
        <div className="shrink-0 space-y-2 md:w-[320px]">
          {['stat-1', 'stat-2', 'stat-3', 'stat-4', 'stat-5'].map((id) => (
            <div key={id} className="h-16 animate-pulse rounded-xl bg-gray-100" />
          ))}
        </div>
      </div>
      <div className="my-2 h-[150px] animate-pulse rounded bg-gray-100" />
    </div>
  );
}
